import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPaginationParams } from '@interfaces';
import { ApiResponse } from '@shared';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AdminPostService {
  constructor(private http: HttpClient) {}
  public allPostsSubject = new BehaviorSubject([]);
  public usersPendingPosts = new BehaviorSubject([]);
  private queryParamsSubject = new BehaviorSubject<IPaginationParams>({
    pageLimit: 10,
    pageNum: 1,
    search: '',
  });
  public $allPosts = this.allPostsSubject.asObservable();
  public $usersPendingPosts = this.usersPendingPosts.asObservable();
  public queryParams$ = this.queryParamsSubject.asObservable();
  updateQueryParams(params: IPaginationParams): void {
    this.queryParamsSubject.next(params);
  }
  createAdminPost(adminPostData: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/admin/posts', adminPostData);
  }

  createSurvey(surveyData: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/admin/posts/create-survey', surveyData);
  }

  createEvent(eventData: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/admin/events', eventData);
  }

  getAllPosts(params: any, lang?: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/admin/posts', { params, headers: { lang: lang || 'he' } });
  }

  deletePost(id: string): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`/v1/admin/posts/${id}`);
  }

  getParticularPost(id: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`/v1/admin/posts/${id}`);
  }

  updatePosts(id: string, data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/posts/${id}`, data);
  }

  updateSurvey(id: string, data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/posts/update-survey/${id}`, data);
  }

  updateEvent(id: string, data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/events/${id}`, data);
  }

  setPosts(data: any) {
    this.allPostsSubject.next(data);
  }

  setUsersPendingPosts(data: any) {
    this.usersPendingPosts.next(data);
  }

  approveUserPost(id: string, notApproval: boolean = false): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(
      `/v1/admin/user-posts/approve-posts/${id}`,
      {},
      !notApproval
        ? {}
        : {
            params: { notApproval },
          },
    );
  }

  updateUserPost(id: string, data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/user-posts/${id}`, data);
  }

  deleteComment(data: any): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>('/v1/admin/posts/delete-comment', { body: data });
  }

  updateComment(data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>('/v1/admin/posts/update-comment', data);
  }

  commentOnPost(data: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/admin/posts/comment-on-post', data);
  }

  getPostComments(postId: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`/v1/admin/posts/like-comment/${postId}`, { params: { type: 'comment' } });
  }
}
